import React from "react";

function Footer() {
  const date = new Date().getFullYear();
  return (
    <footer className="footer-premium">
      <div className="container presentation-shell px-4 px-lg-5 py-4">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3">
          <div>
            <span className="footer-brand">easyVOG</span>
            <p className="mb-0 footer-text mt-2">
              Plataforma juridica com operacao premium, visual moderno e foco em produtividade.
            </p>
          </div>

          <p className="mb-0 footer-text">
            &copy; {date} EasyVOG. Todos os direitos reservados.
          </p>

          <a
            href="https://www.easyvogplanos.com/politica-de-privacidade/"
            target="_blank"
            rel="noreferrer"
            className="footer-link text-decoration-none"
          >
            Termos de uso e privacidade
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
